/**
 * PRNG seedé, embarqué dans l'état de simulation.
 *
 * La simulation ne doit JAMAIS appeler `Math.random()` ni `Date.now()`
 * (spec §3) : tout aléa passe par ici, et l'état du générateur fait partie du
 * `SimState`, donc du rejeu et de la réconciliation réseau.
 */
export interface RngState {
  readonly seed: number;
  readonly counter: number;
}

export function createRng(seed: number): RngState {
  return { seed: seed >>> 0, counter: 0 };
}

/** mulberry32 : rapide, 32 bits, suffisant pour du gameplay. */
export function nextRandom(state: RngState): { readonly value: number; readonly rng: RngState } {
  const counter = state.counter + 1;
  let t = (state.seed + counter * 0x6d2b79f5) >>> 0;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  const value = ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  return { value, rng: { seed: state.seed, counter } };
}
